<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M8.85205 8.85254L11.1854 11.1859"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.1483 5.4821C10.1483 2.90477 8.05894 0.81543 5.48161 0.81543C2.90428 0.81543 0.814941 2.90477 0.814941 5.4821C0.814941 8.05943 2.90428 10.1488 5.48161 10.1488C8.05894 10.1488 10.1483 8.05943 10.1483 5.4821Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linejoin="round"
    />
    <path
      d="M3.66675 5.48181L7.29638 5.48181M5.48156 3.66699V7.29662"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
